import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, User, Gift, Camera, Map } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, language } = useLanguage();
  const { user } = useAuth();

  const navItems = [
    { icon: Home, label: t('home'), path: "/" },
    { icon: Map, label: language === 'es' ? 'Mapa' : 'Map', path: "/map" },
    { icon: Camera, label: language === 'es' ? 'Recientes' : 'Recent', path: "/recent" },
    { icon: Gift, label: t('rewards') || (language === 'es' ? 'Recompensas' : 'Rewards'), path: "/promoslocales" },
    { icon: User, label: t('profile'), path: "/profile" }
  ];

  return (
    <nav className="bottom-menu fixed bottom-0 left-0 right-0 z-[9999] bg-background/98 backdrop-blur-md border-t border-border safe-area-pb shadow-2xl shadow-black/20">
      <div className="w-full grid grid-cols-5 h-18 sm:h-16 px-2">
        {navItems.map((item) => {
          const IconComponent = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Button
              key={item.path}
              variant="ghost"
              onClick={() => {
                if (item.path === "/profile" && !user) {
                  navigate("/auth");
                } else {
                  navigate(item.path);
                }
              }}
              className={`w-full h-full rounded-none flex flex-col gap-0.5 items-center justify-center min-h-[60px] min-w-[60px] min-tap-target touch-manipulation active:scale-95 transition-all ${
                isActive ? "text-primary bg-primary/10" : "text-muted-foreground"
              }`}
            >
              <IconComponent className="w-6 h-6" />
              <span className="text-xs font-medium truncate max-w-[70px]">{item.label}</span>
            </Button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;